import { AxiosResponse } from 'axios';
import React, { useState, useEffect } from 'react';
import { Trans } from 'react-i18next';

import SiteApi from '../../Api/SiteApi/SiteApi';
import { formatCurrency, getFractionDigits } from '../../utils/formatters';

type RandomWinner = {
    currency_code: string;
    lottery_logo: string;
    lottery_name: string;
    prize: string;
    user_name: string;
};

function WinnersToast() {
    const [toastData, setToastData] = useState<RandomWinner>(null);
    const [toastPosition, setToastPosition] = useState('');
    const maxTime: number = process.env.MIX_WINNERS_TOAST_MAX_TIME
        ? parseInt(process.env.MIX_WINNERS_TOAST_MAX_TIME)
        : 10;
    let timer = null;

    useEffect(() => {
        if (!timer && toastPosition === '') {
            SiteApi.get('winners/random').then((response: AxiosResponse<RandomWinner>) => {
                if (!Object.keys(response.data).length) {
                    return;
                }

                setToastData(response.data);
                setNewTimer();
            });
        }

        return () => clearTimeout(timer);
    }, [toastPosition]);

    function setNewTimer() {
        const time = Math.random() * (maxTime * 60000 - 1000) + 1000;

        timer = setTimeout(() => {
            setToastPosition('bottom-right');
            setTimeout(hideToast, 5000);
        }, time);
    }

    function hideToast() {
        setToastPosition('');
    }

    function getPrizeAmount() {
        return formatCurrency(parseFloat(toastData.prize), getFractionDigits(), toastData.currency_code);
    }

    if (!toastData) {
        return null;
    }

    return (
        <div className={`toast-container ${toastPosition}`}>
            <button type="button" onClick={() => hideToast()}>
                <i className="fas fa-times" />
            </button>
            <div className="toast-content row no-gutters">
                <div className="toast-image col-2">
                    <img src={toastData.lottery_logo} alt={toastData.lottery_name} />
                </div>
                <div className="col-10">
                    <div className="toast-title">{toastData.user_name}</div>
                    <div className="toast-message">
                        <span>
                            <Trans
                                i18nKey="winnerToast.wonInfo"
                                prize={toastData.prize}
                                lotteryName={toastData.lottery_name}
                            >
                                just won <mark>{{ prize: getPrizeAmount() }}</mark> in{' '}
                                {{ lotteryName: toastData.lottery_name }}
                            </Trans>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WinnersToast;
